import type { FallbackProps } from "react-error-boundary";
import { Center } from "widgets";

import { FallbackPanel } from "@/modules/workflow/components/ErrorFallbackPanel.tsx";

export function Fallback(props: FallbackProps) {
  return (
    <Center style={{ height: "100%" }}>
      <FallbackPanel {...props} />
    </Center>
  );
}
